/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'

import PropTypes from 'prop-types'

import {Text} from '@salesforce/retail-react-app/app/components/shared/ui'

import {useItemVariant} from '.'

/**
 * In the context of a cart product item variant, this components simply renders
 * the item's name using the cart item field `productName`. We use this field
 * rather than variant `name` field as the variant detail may not yet be
 * available upon rendering.
 */
const ItemName = ({productNameStyles, fontSize, fontWeight, color, ...props}) => {
    const variant = useItemVariant()

    return (
        <Text
            fontWeight={fontWeight || 'bold'}
            fontSize={fontSize || productNameStyles?.size}
            color={color || productNameStyles?.color?.hex}
            {...props}
        >
            {variant.c_customProductName || variant.productName || variant.name}
        </Text>
    )
}

ItemName.displayName = 'ItemName'

ItemName.propTypes = {
    productNameStyles: PropTypes.object,
    fontSize: PropTypes.string,
    fontWeight: PropTypes.string
}

export default ItemName
